import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { SHOW_TOAST } from "@/assets/ts/Constants";
import { ref, inject, onMounted } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

var mitt = inject("emitter") as any;

var config = ref<toastConfig>({ title: "", msg: "", type: "success" });
var show = ref(false);

mitt.on(SHOW_TOAST, (c: toastConfig) => {
  config.value = c;
  show.value = true;

  setTimeout(() => {
    show.value = false;
  }, 5000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "toast-container",
    class: _normalizeClass(["flex", [_unref(config).type, _unref(show) ? 'show' : '']])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("strong", null, _toDisplayString(_unref(config).title), 1)
    ]),
    _createElementVNode("div", null, _toDisplayString(_unref(config).msg), 1)
  ], 2))
}
}

})